export default __webpack_public_path__ + "static/media/s-16.6de3f0f2.jpg";